export interface IDocumentGenerationResult {
    documentName: string;
    documentVersion: number;
    template: string;
    templateVersion: number;
    status: string;
    ready: boolean;
    retry: boolean;
    url: string | undefined;
}

export class DocumentGenerationResult implements IDocumentGenerationResult {
    documentName: string;
    documentVersion: number;
    template: string;
    templateVersion: number;
    status: string;
    ready: boolean;
    retry: boolean;
    url: string | undefined;

    constructor(data?: IDocumentGenerationResult) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data["documentName"];
            this.documentVersion = _data["documentVersion"];
            this.template = _data["template"];
            this.templateVersion = _data["templateVersion"];
            this.status = _data["status"];
            this.ready = _data["ready"];
            this.retry = _data["retry"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): DocumentGenerationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentGenerationResult();
        result.init(data);
        return result;
    }
}